import React from 'react'

import { CardRow, Card, Title, Combination } from './CustomRulesStyled'
import { colors } from 'lib/colors'

export default function Combinations(coefs: any) {
  return (
    <>
      {coefs.coefs.map((item: any, id: number) => (
        <Combination key={id}>
          <div>
            <Title>{item.combinationName}</Title>
            <span>{item.coef} to 1</span>
          </div>
          <CardRow className='cardRow'>
            {item.cards.map((card: any, index: number) => (
              <Card
                className='card'
                key={index}
                isWin={card.win}
                colors={card.color}
                background={colors.cardWhite}
              >
                <p>{card.name}</p>
                {card.suit}
              </Card>
            ))}
          </CardRow>
        </Combination>
      ))}
    </>
  )
}
